import React from "react";

const BASE_WIDTH = 24;
const BASE_HEIGHT = 25;

export default function ArticleIcon(props: {
  height?: number;
  width?: number;
}) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 15.5H20M9 11.5H13M9 7.5H13M6 19C6 19.663 5.73661 20.2989 5.26777 20.7678C4.79893 21.2366 4.16304 21.5 3.5 21.5M6 19L6.025 7.5H2C1.44772 7.5 1 7.94772 1 8.5V19C1 19.663 1.26339 20.2989 1.73223 20.7678C2.20108 21.2366 2.83696 21.5 3.5 21.5M6 19V4.5C6 3.94772 6.44772 3.5 7 3.5H22C22.5523 3.5 23 3.94772 23 4.5V19C23 19.663 22.7366 20.2989 22.2678 20.7678C21.7989 21.2366 21.163 21.5 20.5 21.5H3.5M16 7.5H19V11.5H16V7.5Z"
        stroke="#B4B4BB"
        strokeWidth="2"
      />
    </svg>
  );
}
